import { render, staticRenderFns } from "./diagnosis-consultation-modal-consultation-display.vue?vue&type=template&id=764d0373&scoped=true&"
import script from "./diagnosis-consultation-modal-consultation-display.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal-consultation-display.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal-consultation-display.scss?vue&type=style&index=0&id=764d0373&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d0373",
  null
  
)

export default component.exports